import * as React from "react";
import { useState, useMemo } from "react";
import ExportSettingsContext from "views/components/ExportSettingsContext";
const ExportSettingsContextProvider = ({ children }) => {
  const [exportSettings, setExportSettings] = useState();
  const exportSettingsContextValue = useMemo(
    () => ({
      settings: exportSettings,
      setSettings: setExportSettings
    }),
    [exportSettings]
  );
  return /* @__PURE__ */ React.createElement(ExportSettingsContext.Provider, { value: exportSettingsContextValue }, children);
};
export default ExportSettingsContextProvider;
